import api from "./api";
import axiosClient from "../axiosClient";

export const getMarketplaceConversation =
    async (
        inquiryId,
        countryCode
    ) => {

        const response =
            await api.get(

                `/shipping/inquiry/${inquiryId}/conversation`,

                {
                    headers: {
                        "X-Country-Code": countryCode
                    }
                }
            );

        return response.data;
    };

export const sendConversationMessage =
    async (
        inquiryId,
        payload,
        countryCode
    ) => {

        const response =
            await api.post(

                `/shipping/inquiry/${inquiryId}/conversation/messages`,

                payload,

                {
                    headers: {
                        "X-Country-Code": countryCode
                    }
                }
            );

        return response.data;
    };

export const getConversationMessage =
    async (
        inquiryId,
        countryCode
    ) => {

        const response =
            await api.get(

                `/shipping/inquiry/${inquiryId}/conversation/messages`,

                {
                    headers: {
                        "X-Country-Code": countryCode
                    }
                }
            );

        return response.data;
    };

export const sendOffer =
    async (
        inquiryId,
        payload,
        countryCode
    ) => {

        const response =
            await api.post(

                `/shipping/inquiry/${inquiryId}/offer`,

                payload,

                {
                    headers: {
                        "X-Country-Code": countryCode
                    }
                }
            );

        return response.data;
    };

export const getConversation = (
    inquiryId,
    countryCode
) => {

    return axiosClient.get(

        `/shipping/inquiry/${inquiryId}`,

        {
            headers: {
                "X-Country-Code": countryCode
            }
        }

    );
};

export const createInquiry = async (
    payload,
    countryCode
) => {

    const response = await api.post(

        "/shipping/inquiry/create",

        payload,

        {
            headers: {
                "X-Country-Code": countryCode
            }
        }
    );

    return response.data;
};